import { Copy } from "lucide-react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";

interface ContactInfoProps {
	label: string;
	name: string;
	number: string;
}

export function ContactInfo({ label, name, number }: ContactInfoProps) {
	const handleClick = () => {
		navigator.clipboard.writeText(number);
		toast.success("Phone number copied");
	};

	return (
		<div className="flex flex-wrap items-center justify-between py-3">
			<div>
				<div className="text-gray-500">{label}</div>
				<div>{name}</div>
			</div>
			<div className="flex items-center gap-2">
				<span>{number}</span>
				{number && (
					<Button variant="ghost" size="icon" className="h-8 w-8" onClick={handleClick}>
						<Copy className="h-4 w-4" />
					</Button>
				)}
			</div>
		</div>
	);
}
